export enum BUCKETS {
  EXPORTS = 'exports',
  MMS = 'mms-uploads',
  OPTOUTS = 'optouts',
  OPTOUTS_EXTERNAL = 'optout-uploads-external',
  OPTOUTS_UNDO = 'optout-undo',
  CONTACTS = 'contact-uploads',
  SUPPRESSIONS = 'suppression-uploads',
  LINK_ORDERS = 'link-orders',
  GENERATED_LINKS = 'generated-links',
  ARCHIVE_S3 = 's3-bucket-archive',
  REPORTS = 'reports',
  REBRANDLY_LINK_CLICKS = 'rebrandly-link-clicks',
  UTILITY_DNC_LOOKUP = 'utility-dnc-lookup',
  UTILITY_DNC_CLEAN = 'utility-dnc-clean',
  CONTACTS_RE_ENGAGEMENT = 'contacts-re-engagement',
};
